import { principalToString } from './types/principalCV';
import { ClarityType } from './constants';
import { asciiToBytes, bytesToAscii, bytesToHex, utf8ToBytes } from '@stacks/common';
export function cvToString(val) {
  var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hex';

  switch (val.type) {
    case ClarityType.BoolTrue:
      return 'true';

    case ClarityType.BoolFalse:
      return 'false';

    case ClarityType.Int:
      return val.value.toString();

    case ClarityType.UInt:
      return "u".concat(val.value.toString());

    case ClarityType.Buffer:
      if (encoding === 'tryAscii') {
        var str = bytesToAscii(val.buffer);

        if (/[ -~]/.test(str)) {
          return JSON.stringify(str);
        }
      }

      return "0x".concat(bytesToHex(val.buffer));

    case ClarityType.OptionalNone:
      return 'none';

    case ClarityType.OptionalSome:
      return "(some ".concat(cvToString(val.value, encoding), ")");

    case ClarityType.ResponseErr:
      return "(err ".concat(cvToString(val.value, encoding), ")");

    case ClarityType.ResponseOk:
      return "(ok ".concat(cvToString(val.value, encoding), ")");

    case ClarityType.PrincipalStandard:
    case ClarityType.PrincipalContract:
      return principalToString(val);

    case ClarityType.List:
      return "(list ".concat(val.list.map(function (v) {
        return cvToString(v, encoding);
      }).join(' '), ")");

    case ClarityType.Tuple:
      return "(tuple ".concat(Object.keys(val.data).map(function (key) {
        return "(".concat(key, " ").concat(cvToString(val.data[key], encoding), ")");
      }).join(' '), ")");

    case ClarityType.StringASCII:
      return "\"".concat(val.data, "\"");

    case ClarityType.StringUTF8:
      return "u\"".concat(val.data, "\"");
  }
}
export function cvToValue(val) {
  var strictJsonCompat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  switch (val.type) {
    case ClarityType.BoolTrue:
      return true;

    case ClarityType.BoolFalse:
      return false;

    case ClarityType.Int:
    case ClarityType.UInt:
      if (strictJsonCompat) {
        return val.value.toString();
      }

      return val.value;

    case ClarityType.Buffer:
      return "0x".concat(bytesToHex(val.buffer));

    case ClarityType.OptionalNone:
      return null;

    case ClarityType.OptionalSome:
      return cvToJSON(val.value);

    case ClarityType.ResponseErr:
      return cvToJSON(val.value);

    case ClarityType.ResponseOk:
      return cvToJSON(val.value);

    case ClarityType.PrincipalStandard:
    case ClarityType.PrincipalContract:
      return principalToString(val);

    case ClarityType.List:
      return val.list.map(function (v) {
        return cvToJSON(v);
      });

    case ClarityType.Tuple:
      var result = {};
      Object.keys(val.data).forEach(function (key) {
        result[key] = cvToJSON(val.data[key]);
      });
      return result;

    case ClarityType.StringASCII:
      return val.data;

    case ClarityType.StringUTF8:
      return val.data;
  }
}
export function cvToJSON(val) {
  switch (val.type) {
    case ClarityType.ResponseErr:
      return {
        type: getCVTypeString(val),
        value: cvToValue(val, true),
        success: false
      };

    case ClarityType.ResponseOk:
      return {
        type: getCVTypeString(val),
        value: cvToValue(val, true),
        success: true
      };

    default:
      return {
        type: getCVTypeString(val),
        value: cvToValue(val, true)
      };
  }
}
export function getCVTypeString(val) {
  switch (val.type) {
    case ClarityType.BoolTrue:
    case ClarityType.BoolFalse:
      return 'bool';

    case ClarityType.Int:
      return 'int';

    case ClarityType.UInt:
      return 'uint';

    case ClarityType.Buffer:
      return "(buff ".concat(val.buffer.length, ")");

    case ClarityType.OptionalNone:
      return '(optional none)';

    case ClarityType.OptionalSome:
      return "(optional ".concat(getCVTypeString(val.value), ")");

    case ClarityType.ResponseErr:
      return "(response UnknownType ".concat(getCVTypeString(val.value), ")");

    case ClarityType.ResponseOk:
      return "(response ".concat(getCVTypeString(val.value), " UnknownType)");

    case ClarityType.PrincipalStandard:
    case ClarityType.PrincipalContract:
      return 'principal';

    case ClarityType.List:
      return "(list ".concat(val.list.length, " ").concat(val.list.length ? getCVTypeString(val.list[0]) : 'UnknownType', ")");

    case ClarityType.Tuple:
      return "(tuple ".concat(Object.keys(val.data).map(function (key) {
        return "(".concat(key, " ").concat(getCVTypeString(val.data[key]), ")");
      }).join(' '), ")");

    case ClarityType.StringASCII:
      return "(string-ascii ".concat(asciiToBytes(val.data).length, ")");

    case ClarityType.StringUTF8:
      return "(string-utf8 ".concat(utf8ToBytes(val.data).length, ")");
  }
}